import { find } from "../../Interactions/Finder";
import { Actions } from "./actions";
import { Keyword, reducer } from "./reducer";
export const parseFilter = ({ text, defaultFilter, whitelist = [] }) => {
    /**
     * find the two parts of some string like "device: router"
     * and keep "device" and "router", which would be the filter name and
     * the filter value
     */
    const re = /^\s*(\b.+\b)\s*:\s*(\b.+\b)\s*$/imu;
    const [, name, value] = re.exec(text) || [];
    if (name && value) {
        if (whitelist.includes(name.toLowerCase())) {
            return { name, value };
        }
    }
    return { name: defaultFilter, value: text };
};
export const router = {
    [Actions.INPUT_FOCUS]: (state, payload) => {
        const { whitelist } = state;
        return Object.assign(Object.assign({}, state), { focused: true, placeholderVisible: false, showResults: whitelist.length <= 1 && payload.length > 0, tooltipVisible: true });
    },
    [Actions.INPUT_BLUR]: (state) => (Object.assign(Object.assign({}, state), { focused: false, placeholderVisible: state.filters.length === 0, tooltipVisible: false })),
    [Actions.KEYUP_CAPTURE]: (state, payload) => {
        const { key } = payload;
        const action = `KEYUP_${key}`;
        const keyUpState = action in router ? reducer(state, { payload, type: action }) : {};
        return Object.assign(Object.assign({}, state), keyUpState);
    },
    [Actions.RESET]: (state) => (Object.assign(Object.assign({}, state), { filters: [], inputText: "", keyword: undefined, prefix: undefined, reset: false, search: "", showResults: false, tooltipVisible: false })),
    [Actions.KEYUP_ESCAPE]: (state) => reducer(state, { type: Actions.RESET }),
    [Actions.AUTOCOMPLETE_CLICK]: (state, filter) => {
        const newState = Object.assign(Object.assign({}, state), { inputText: "", showResults: false, tooltipVisible: false });
        return reducer(newState, {
            payload: filter,
            type: Actions.ADD_FILTER_CHIP,
        });
    },
    [Actions.INPUT_CHANGED]: (state, text) => {
        const baseState = Object.assign(Object.assign({}, state), { inputText: text, search: text, showResults: text !== "", tooltipVisible: true });
        const keywordCheckState = reducer(baseState, { type: Actions.CHECK_KEYWORD });
        const prefixCheckState = reducer(keywordCheckState, { type: Actions.CHECK_PREFIX });
        return reducer(prefixCheckState, { type: Actions.PREPARE_FINDER });
    },
    [Actions.PREPARE_FINDER]: (state) => {
        const { minLengthSearch, prefix, search } = state;
        const filterer = (collection) => prefix
            ? find(search, collection.filter(({ title }) => (title === null || title === void 0 ? void 0 : title.toLowerCase()) === prefix.toLowerCase()), { minimum: minLengthSearch })
            : find(search, collection, { minimum: minLengthSearch });
        return Object.assign(Object.assign({}, state), { filterer,
            search });
    },
    [Actions.UPDATE_VALUE]: (state, filters) => (Object.assign(Object.assign({}, state), { filters })),
    [Actions.CHECK_KEYWORD]: (state) => {
        const { keywords, keyword, search, inputText } = state;
        if (search.endsWith(":")) {
            const foundKeyword = search.slice(0, -1);
            if (keywords.includes(foundKeyword)) {
                return Object.assign(Object.assign({}, state), { keyword: foundKeyword, search: search.replace(`${foundKeyword}:`, "") });
            }
        }
        return Object.assign(Object.assign({}, state), { keyword: keyword && inputText.includes(keyword) ? keyword : undefined, search: keyword ? search.replace(`${keyword}:`, "") : search });
    },
    [Actions.CHECK_PREFIX]: (state) => {
        const { prefix, search, inputText, whitelist } = state;
        if (search.endsWith(":")) {
            const foundPrefix = search.slice(0, -1);
            if (whitelist.includes(foundPrefix.toLowerCase())) {
                return Object.assign(Object.assign({}, state), { prefix: foundPrefix, search: "" });
            }
        }
        return Object.assign(Object.assign({}, state), { prefix: prefix && inputText.includes(prefix) ? prefix : undefined, search: prefix ? search.replace(`${prefix}:`, "") : search });
    },
    [Actions.ADD_FILTER_CHIP]: (state, filter) => {
        const { filters, keyword, isMultiFilter } = state;
        const outState = reducer(reducer(state, { type: Actions.RESET }), { type: Actions.PREPARE_FINDER });
        if (keyword === Keyword.NOT) {
            // eslint-disable-next-line no-param-reassign
            filter.negate = true;
        }
        const hasFilter = filters.find((f) => f.name === filter.name && f.value === filter.value);
        if (isMultiFilter) {
            return Object.assign(Object.assign({}, outState), { canSubmit: true, filters: hasFilter ? filters : [...filters, filter], placeholderVisible: filters.length < 0, showResults: false });
        }
        return Object.assign(Object.assign({}, outState), { canSubmit: true, filters: [filter], keyword: undefined, placeholderVisible: filters.length < 0, prefix: undefined, showResults: false });
    },
    [Actions.REMOVE_FILTER_CHIP]: (state, filter) => {
        const filters = state.filters.filter((f) => f !== filter);
        return Object.assign(Object.assign({}, state), { canSubmit: true, filters, placeholderVisible: filters.length === 0 });
    },
    [Actions.SEARCHBOX_SUBMITTED]: (state) => (Object.assign(Object.assign({}, state), { canSubmit: false })),
};
